import { useTheme } from '@common/theme-layer/composables/useTheme'

export default defineNuxtPlugin(nuxtApp => {
  const { applySessionTheme, currentTheme } = useTheme()

  const reapplyCurrentTheme = () => {
    applySessionTheme(currentTheme.value)
  }

  reapplyCurrentTheme()
  nuxtApp.hook('page:finish', reapplyCurrentTheme)
})
